import React, { useState, useEffect } from 'react';
import './SearchBar.scss';
import FontAwesome from 'react-fontawesome';

interface SearchBarProps {
    placeholder?: string;
    onSearch: (searchTerm: string) => void;
    isLoading?: boolean;
    onClear?: () => void;
    value?: string; // Optional controlled value from parent
}

const SearchBar: React.FC<SearchBarProps> = ({
    placeholder = 'Search...',
    onSearch,
    isLoading = false,
    onClear,
    value
}) => {
    const [searchTerm, setSearchTerm] = useState<string>(value || '');

    // Sync with parent value if provided
    useEffect(() => {
        if (value !== undefined) {
            setSearchTerm(value);
        }
    }, [value]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onSearch(searchTerm.trim());
        }
    };

    const handleSearchClick = () => {
        onSearch(searchTerm.trim());
    };

    const handleClear = () => {
        setSearchTerm('');
        onClear && onClear();
    };

    return (
        <div className="search-bar-container">
            <div className="search-bar">
                <input
                    type="text"
                    placeholder={placeholder}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={handleKeyDown}
                    disabled={isLoading}
                    className="search-input"
                />
                {searchTerm && (
                    <button
                        className="search-clear-btn"
                        onClick={handleClear}
                        disabled={isLoading}
                        type="button"
                    >
                        <FontAwesome name="times" />
                    </button>
                )}
                <button
                    className="search-btn"
                    onClick={handleSearchClick}
                    disabled={isLoading}
                    type="button"
                >
                    {isLoading ? (
                        <FontAwesome name="spinner" spin />
                    ) : (
                        <FontAwesome name="search" />
                    )}
                </button>
            </div>
        </div>
    );
};

export default SearchBar;

